import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'

const url = 'notifications'
const plural = 'notifications'
const single = 'notification'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: false,
	update: true,
	remove: true,
	url: url,
	plural: plural,
	single: single
})

// api.index = () => {
// 	return axios
// 		.get(`${apiProvider.BASE_URL}/${url}`)
// 		.then(handleResponse)
// 		.catch(handleError);
// }


api.update = (action,payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/action/${action}`,payload)
		.then(handleResponse)
		.catch(handleError);
}


api.remove = (action,payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/action/${action}`,payload)
		.then(handleResponse)
		.catch(handleError);
}
export default api
